import { format } from 'date-fns';

export const formatDate = (d: Date): string => format(d, 'MM/dd/yyyy HH:mm');
